export default {
  name: 'tab-bar',
  data() {
    return {
      active: 0,
      // 默认选中的 Tab 索引
      activehome: require('@/assets/image/ic_tab_home_s.png'),
      inactivehome: require('@/assets/image/ic_tab_home_u.png'),
      activeflow: require('@/assets/image/ic_flow_inquiry_s.png'),
      inactiveflow: require('@/assets/image/ic_flow_inquiry_u.png'),
      activeMy: require('@/assets/image/ic_tab_mine_s.png'),
      inactiveMy: require('@/assets/image/ic_tab_mine_u.png')
    };
  },
  watch: {
    $route(to, from) {
      // 只在路由名称变化时更新选中的选项卡
      if (to.name !== from.name) {
        this.active = this.getTabIndexFromRoute(to.name);
      }
    }
  },
  methods: {
    getTabIndexFromRoute(routeName) {
      // 根据路由名称获取选项卡索引的方法
      switch (routeName) {
        case 'flow':
          return 1;
        case 'my':
          return 2;
        default:
          return 0;
        // 默认为首页
      }
    }
  }
};